export default "assets/spinner-0a0a704a.gif";